import { Injectable, inject } from '@angular/core';
import { AbstractCrudOperations, ServiceTransactionsEnum, RoleRequirements } from './abstract/abstract-crud-operations';
import { ExtractionRule, ExtractionRuleCreate, ExtractionRuleUpdate, Role } from './model';
import { AuthService } from './auth.service';

export enum ExtractionRuleTransactionsEnum {
  GET_ALL = 'extraction-rule-get-all',
  GET_BY_ID = 'extraction-rule-get-by-id',
  CREATE = 'extraction-rule-create',
  UPDATE = 'extraction-rule-update',
  DELETE = 'extraction-rule-delete',
}

@Injectable({
  providedIn: 'root',
})
export class ExtractionRuleService extends AbstractCrudOperations<
  ExtractionRule,
  ExtractionRuleCreate,
  ExtractionRuleUpdate
> {
  protected override transactions: Record<ServiceTransactionsEnum, string> = {
    [ServiceTransactionsEnum.GET_ALL]: ExtractionRuleTransactionsEnum.GET_ALL,
    [ServiceTransactionsEnum.GET_BY_ID]: ExtractionRuleTransactionsEnum.GET_BY_ID,
    [ServiceTransactionsEnum.CREATE]: ExtractionRuleTransactionsEnum.CREATE,
    [ServiceTransactionsEnum.UPDATE]: ExtractionRuleTransactionsEnum.UPDATE,
    [ServiceTransactionsEnum.DELETE]: ExtractionRuleTransactionsEnum.DELETE,
  };

  override readonly resource = 'extraction-rules';

  protected override roleRequirements: RoleRequirements = {
    create: [Role.Admin, Role.Manager],
    update: [Role.Admin, Role.Manager, Role.User],
    delete: [Role.Admin, Role.Manager],
  };

  protected override authService = inject(AuthService);
}
